import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  { path: '/layout/speciality', title: 'Speciality', icon: 'material-icons' },
  { path: '/layout/procedure', title: 'Procedure', icon: 'material-icons' },
  { path: '/layout/equipment', title: 'Equipment', icon: 'material-icons' },
  { path: '/layout/surgeonlist', title: 'Surgeon List', icon: 'material-icons' },
  { path: '/layout/journal', title: 'Calendar', icon: 'material-icons' },
  { path: '/layout/manage-journal', title: 'Manage Journal', icon: 'material-icons' },
  { path: '/layout/manage-contact', title: 'Manage Contact', icon: 'material-icons' },
  { path: '/layout/professional-training', title: 'Professional Learning', icon: 'material-icons' },
  { path: '/layout/impersonation', title: 'Impersonate', icon: 'material-icons' },
  { path: '/layout/reported-images', title: 'Reported Images', icon: 'material-icons' },
  { path: '/layout/subscription', title: 'Subscription', icon: 'material-icons' },
  { path: '/layout/user-speciality', title: 'Specialties', icon: 'material-icons' },
  { path: '/layout/user-procedure', title: 'User Procedure', icon: 'material-icons' },
  { path: '/layout/shift-daytime', title: 'Shift Day & Time', icon: 'material-icons' },
  { path: '/layout/release-speciality', title: 'Release To AppStore', icon: 'material-icons' },
  { path: '/layout/analytics', title: 'Analytics', icon: 'material-icons' },
  { path: '/layout/users-report', title: 'Users', icon: 'material-icons' },
  { path: '/layout/user-roles-report', title: 'User Roles', icon: 'material-icons' },
  { path: '/layout/other-statistics-report', title: 'Other Statistics', icon: 'material-icons' },
  { path: '/layout/speciality-procedure-report', title: 'Procedures', icon: 'material-icons' },
  { path: '/layout/surgeon-report', title: 'Surgeons', icon: 'material-icons' },
  { path: '/layout/speciality-download-report', title: 'Specialities Downloaded', icon: 'material-icons' },
];



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/sidebar/sidebar-routes.config.ts